module.exports = __webpack_public_path__ + "static/media/smoke_false_passive.5404e783.jpg";